module.exports = __webpack_public_path__ + "thavRedBig.png?cf88d4ff1abd10200732d5ad4cd18dd5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thavRedBig.png
// module id = 14
// module chunks = 0